import React from 'react';
import { Provider } from 'react-redux';

import store from '../store';

import { Switch, Route, Redirect } from 'react-router-dom';

import { onAppEnter } from './route_callbacks';

import ResetPassword from '../components/resetPassword';
import Login from '../components/login';
import Logout from '../components/logout';

import Header from '../components/header';
import Footer from '../components/footer';

import TakeAssessment from '../components/takeAssessment';

import Home from '../components/home';
import People from '../components/people';
//import Person from '../components/people/person';
import Teams from '../components/teams';
import AllTeams from '../components/teams/all';
import TeamDetails from '../components/teams/details';
import Resources from '../components/resources';
import Reports from '../components/reports';
import Insights from '../components/insights';
import Settings from '../components/settings';

import Assessments from '../components/assessments';

import Imperatives from '../components/imperatives';
import ImperativesDealFunnel from '../components/imperatives/funnel';
import ImperativesDeal from '../components/imperatives/deal/index';
import Sprint from '../components/sprint';
import Plan from '../components/plan';
import Talents from '../components/talents';
import PredictiveSkillsReview from '../components/salesCompetencies';
import ViewSalesCompetencyReview from '../components/salesCompetencies/viewSalesCompetencyReview';
import EditSalesCompetencyReview from '../components/salesCompetencies/editSalesCompetencyReview';

import Deals from '../components/deals';
import Deal from '../components/deal';

import StrengthsPage from '../components/strengths';
//import KnowYourStrengths from '../components/know';
import PlayToYourStrengths from '../components/play';
import ImproveYourSkills from '../components/improve';
import ShowcaseYourStrengths from '../components/showcase';
import ReviewResponses from '../components/responses';
import Profile from '../components/profile';

import SprintSetup from '../components/sprint/setup';

import TalentAndCultureMatch from '../components/match';
import PredictiveSummary from '../components/predictive';
import InterviewQuestions from '../components/interview';
import WinnersCard from '../components/winner';

import Report from '../components/report_deprecated';
import BechtelReport from '../components/report_deprecated/bechtel';
import WestinghouseReport from '../components/report_deprecated/westinghouse';
import CompetitiveAdvantageReport from '../components/report_deprecated/competitiveAdvantage';

import Organizations from '../components/organizations';

import Admin from '../components/admin';
import AdminExport from '../components/adminexport';

import Export from '../components/export';

import PasswordTest from '../components/public/passwordTest';
import NetworkTest from '../components/public/networkTest';

import { getCurrentUser } from '../util';

import RequireAuth from './requireAuth';
import RequireAdmin from './requireAdmin';

import { syncUser } from '../actions';

//sync user for all non-public routes
if(document.location.pathname.indexOf('/public/') === -1){
  store.dispatch(syncUser());
}

//passing props to components
//https://tylermcginnis.com/react-router-pass-props-to-components/

const Routes = () => (
  <Provider store={store}>
    <template className="full-height">
      <Header />
      <Switch>
        <Route exact path='/resetPassword' component={ResetPassword} />
        <Route exact path='/login' component={Login} />
        <Route exact path='/logout' component={Logout} />

        <Route exact path='/a/' component={TakeAssessment} />
        <Route exact path='/a/:assessmentName' component={TakeAssessment} />

        <Route exact path='/export/:reportName' component={Export} />

        <Route exact path='/public/passwordTest' component={PasswordTest} />
        <Route exact path='/public/networkTest' component={NetworkTest} />

        {/*For manual report exports only*/}

        <Route exact path='/report/westinghouse/:ProfileID' component={WestinghouseReport} />
        <Route exact path='/report/bechtel/:ProfileID' component={BechtelReport} />
        <Route exact path='/report/advantage/:ProfileID' component={CompetitiveAdvantageReport} />
        <Route exact path='/report/:ProfileID' component={Report} />


        <RequireAuth>

          <Route exact path='/' component={Home} />

          <Route exact path='/adminexport/:selectedExportTool' component={AdminExport} />
          <Route exact path='/adminexport' component={AdminExport} />

          <Route exact path='/imperatives-funnel' component={ImperativesDealFunnel} />
          <Route exact path='/imperatives/:dealId' component={ImperativesDeal} />
          <Route exact path='/imperatives' component={Imperatives} />

          <Route exact path='/deal/:dealId' component={Deal} />
          <Route exact path='/deals' component={Deals} />

          <Route exact path='/people/:employeeId/imperatives-funnel' component={props => <ImperativesDealFunnel {...props} isViewingUser={true} /> } />
          <Route exact path='/people/:employeeId/imperatives/:dealId' component={props => <ImperativesDeal {...props} isViewingUser={true} /> } />
          <Route exact path='/people/:employeeId/imperatives' component={props => <Imperatives {...props} isViewingUser={true} /> } />

          <Route exact path='/sprint' component={Sprint} />
          <Route exact path='/plan' component={Plan} />
          <Route exact path='/talents' component={Talents} />

          <Route exact path='/salesCompetencies/view/:reviewId' component={ViewSalesCompetencyReview} />
          <Route exact path='/salesCompetencies/edit/:reviewId' component={EditSalesCompetencyReview} />
          <Route exact path='/salesCompetencies' component={PredictiveSkillsReview} />

          <Route exact path='/strengths' component={StrengthsPage} />
          {/*<Route exact path='/know' component={KnowYourStrengths} />*/}
          <Route exact path='/play' component={PlayToYourStrengths} />
          <Route exact path='/improve' component={ImproveYourSkills} />
          <Route exact path='/showcase' component={ShowcaseYourStrengths} />
          <Route exact path='/responses' component={ReviewResponses} />
          <Route exact path='/profile' component={Profile} />

          <Route exact path='/people' component={People} />
          {/*<Route exact path='/people/:employeeId' component={Person} />*/}
          <Route exact path='/people/:employeeId/profile' component={props => <Profile {...props} isViewingUser={true} /> } />
          <Route exact path='/people/:employeeId/match' component={props => <TalentAndCultureMatch {...props} isViewingUser={true} /> } />
          <Route exact path='/people/:employeeId/predictive' component={props => <PredictiveSummary {...props} isViewingUser={true} /> } />
          <Route exact path='/people/:employeeId/interview' component={props => <InterviewQuestions {...props} isViewingUser={true} /> } />
          <Route exact path='/people/:employeeId/winner' component={props => <WinnersCard {...props} isViewingUser={true} /> } />
          <Route exact path='/people/:employeeId/responses' component={props => <ReviewResponses {...props} isViewingUser={true} /> } />

          <Route exact path='/people/:employeeId/sprint' component={props => <Sprint {...props} isViewingUser={true} /> } />
          <Route exact path='/people/:employeeId/sprint/setup' component={props => <SprintSetup {...props} isViewingUser={true} /> } />
          <Route exact path='/people/:employeeId/plan' component={props => <Plan {...props} isViewingUser={true} /> } />
          <Route exact path='/people/:employeeId/talents' component={props => <Talents {...props} isViewingUser={true} /> } />
          <Route exact path='/people/:employeeId/salesCompetencies/view/:reviewId' component={ViewSalesCompetencyReview} />
          <Route exact path='/people/:employeeId/salesCompetencies/edit/:reviewId' component={EditSalesCompetencyReview} />
          <Route exact path='/people/:employeeId/salesCompetencies' component={props => <PredictiveSkillsReview {...props} isViewingUser={true} /> } />

          <Route exact path='/teams' component={Teams} />
          <Route exact path='/all-teams' component={AllTeams} />
          <Route exact path='/teams/:teamId' component={TeamDetails} />

          <Route exact path='/resources' component={Resources} />
          <Route exact path='/reports' component={Reports} />
          <Route exact path='/insights' component={Insights} />

          <Route exact path='/assessments' component={Assessments} />

          <Route exact path='/settings/:pageTab/:integrationCallback' component={Settings} />
          <Route exact path='/settings/:pageTab' component={Settings} />
          <Route exact path='/settings' component={Settings} />

          {/*todo move this to admin settings page*/}
          <Route exact path ='/organizations' component={Organizations} />

          <Route exact path='/admin/:pageTab' component={Admin} />
          <Route exact path='/admin' component={Admin} />

        </RequireAuth>



      </Switch>
      <Footer />
    </template>
  </Provider>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.js